<template>
  <div>
    <home />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Home from '../views/Home.vue'

export default {
  name: "Index",

  components: {},

  data: () => ({
    expandOnHover: false,
    currentClass: "",
    isPublic: false
  }),

  watch: {
    $route(val) {
      this.currentClass = val.name;
      this.isPublic = val.name.includes("Public") ? true : false;
    },
    loggedIn(val) {
      if (!this.isPublic && !this.loggedIn) {
        this.$router.push({
          name: "Login"
        });
      }
    }
  },

  created() {
    this.currentClass = this.$route.name;
    /*
    this.isPublic = this.$route.name.includes("Public") ? true : false;
    if (this.loggedIn && this.$route.name === "PublicDashboard") {
      this.$router.push({
        name: "AdminDashboard"
      });
    } else if (!this.isPublic && !this.loggedIn) {
      this.$router.push({
        name: "Login"
      });
    }
    */
  },
  computed: {
    ...mapState(["loggedIn"])
  },

  methods: {
    ...mapMutations({
      setLoggedIn: "SET_LOGGED_IN"
    })
  }
};
</script>
